export default __webpack_public_path__ + "static/media/antp_ingvehicular_bannerregistro.957340e3.jpg";